import script from "./NewsWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsWidget.vue?vue&type=script&setup=true&lang=js"

import "./NewsWidget.vue?vue&type=style&index=0&id=156db436&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-156db436"]])

export default __exports__